import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

function LanguageSelector() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  const isEnglish = i18n.language === "en";

  return (
    <motion.div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0",
        padding: "4px",
        position: "relative",
        zIndex: 1000,
        borderRadius: "8px",
        border: "1.5px solid rgba(139, 127, 168, 0.3)",
        backgroundColor: "rgba(139, 127, 168, 0.05)",
      }}
      whileHover={{ backgroundColor: "rgba(139, 127, 168, 0.1)" }}
    >
      {/* ID Button */}
      <motion.button
        onClick={() => handleLanguageChange("id")}
        style={{
          padding: "8px 14px",
          border: "none",
          backgroundColor: isEnglish ? "transparent" : "#8b7fa8",
          color: isEnglish ? "#8b7fa8" : "#fff",
          fontSize: "13px",
          fontWeight: isEnglish ? "500" : "700",
          cursor: "pointer",
          borderRadius: "6px",
          transition: "all 0.3s ease",
        }}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        ID
      </motion.button>

      {/* EN Button */}
      <motion.button
        onClick={() => handleLanguageChange("en")}
        style={{
          padding: "8px 14px",
          border: "none",
          backgroundColor: isEnglish ? "#8b7fa8" : "transparent",
          color: isEnglish ? "#fff" : "#8b7fa8",
          fontSize: "13px",
          fontWeight: isEnglish ? "700" : "500",
          cursor: "pointer",
          borderRadius: "6px",
          transition: "all 0.3s ease",
        }}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        EN
      </motion.button>
    </motion.div>
  );
}

export default LanguageSelector;
